import jsCookie from 'js-cookie';

export const USER_COOKIE = 'teleconference.user';
export const DEVICES_COOKIE = 'teleconference.devices';

export function getUser() {
    return jsCookie.getJSON(USER_COOKIE);
}

export function setUser({ displayName }) {
    jsCookie.set(USER_COOKIE, { displayName });
}

export function getDevices() {
    return jsCookie.getJSON(DEVICES_COOKIE);
}

export function setDevices({ webcamEnabled, micEnabled }) {
    jsCookie.set(DEVICES_COOKIE, { webcamEnabled, micEnabled });
}
